
import React from 'react';
import { cn } from '@/lib/utils';
import { LucideProps } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

interface SimpleStatCardProps {
  title: string;
  value: string;
  icon?: React.ElementType<LucideProps>;
  className?: string;
  isLoading?: boolean;
}

const SimpleStatCard: React.FC<SimpleStatCardProps> = ({ 
  title, 
  value, 
  icon: Icon, 
  className,
  isLoading = false 
}) => {
  return (
    <div 
      className={cn(
        "p-4 hover:bg-muted/20 transition-colors duration-150 rounded-lg min-w-[160px] md:min-w-0 flex-shrink-0 md:flex-shrink", 
        className
      )}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{title}</div>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground opacity-60" />}
      </div>
      <div className="text-2xl font-semibold text-foreground">
        {isLoading ? (
          <Skeleton className="h-7 w-16" />
        ) : (
          value
        )}
      </div>
    </div>
  );
};

export default SimpleStatCard;
